import { render, staticRenderFns } from "./TrustpilotFooter.vue?vue&type=template&id=23d983d6&lang=pug"
import script from "./TrustpilotFooter.vue?vue&type=script&lang=ts"
export * from "./TrustpilotFooter.vue?vue&type=script&lang=ts"
import style0 from "./TrustpilotFooter.vue?vue&type=style&index=0&id=23d983d6&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports